import { sliderSmartControlInit } from '../../../snippets/slider-smart-control/slider-smart-control';

window.onReady(() => {
  sliderSmartControlInit();
});
